/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsBoardFinderViewProps } from './hosports-board-finder';

export default (props: IHosportsBoardFinderViewProps) => {
    return (
        <h2>{'Board Finder Page'}</h2>
    );
};
